import {
  WhmBox,
  WhmStack,
  whmTheme,
  WhmTypography,
  WhmTypographyProps,
} from "@securitize/reactjs-whm";
import { ReactComponent as PerformanceUp } from "@securitize/assets-sec-ui/dist/icons/svg/arrow-up-diagonal.svg";
import { ReactComponent as PerformanceDown } from "@securitize/assets-sec-ui/dist/icons/svg/arrow-down-diagonal.svg";
import { iconSmall } from "../../../shared/iconThemes";

export default function Performance({
  value,
  children,
  variant,
}: {
  value: number;
  children: React.ReactNode;
  variant?: WhmTypographyProps["variant"];
}) {
  return (
    <WhmStack direction="row" alignItems="center" gap="4px">
      <WhmBox
        component={value < 0 ? PerformanceDown : PerformanceUp}
        fill={
          value < 0
            ? whmTheme.palette.error.main
            : whmTheme.palette.success.main
        }
        sx={iconSmall}
      />
      <WhmTypography
        variant={variant}
        color={
          value < 0
            ? whmTheme.palette.error.main
            : whmTheme.palette.success.main
        }
      >
        {children}
      </WhmTypography>
    </WhmStack>
  );
}
